import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviantsListCard from '@wix/da-shared-react/pkg/DeviantsList/DeviantsListCard';
import IconButtonWithPopover from '@wix/da-shared-react/pkg/Dropdown/Preset/IconButtonWithPopover';
import SearchDeviants from '@wix/da-ds/pkg/Icons/24x24/SearchDeviants';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './DeviantsSearchButton.scss';

export interface Props {
  className?: string;
  selectedUserId?: number;
  feedType?: string;
  showDeviantsListModal: (
    selectedUserId?: number,
    onItemClick?: (user: PapiUser) => void
  ) => void;
}

const DeviantsSearchButton: React.FC<Props> = ({
  selectedUserId,
  feedType,
  showDeviantsListModal,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const onItemClick = useCallback(
    (user: PapiUser) => {
      window.location.assign(
        Url.browseDeviantsYouWatchLink(feedType as any, user.username)
      );
    },
    [feedType]
  );

  return isMobile ? (
    <IconButton
      size="medium"
      icon={SearchDeviants}
      onClick={() => showDeviantsListModal(selectedUserId, onItemClick)}
      biData={{
        evid: BiEventType.MORE_MENU_CLICK,
      }}
      aria-label={t(
        'deviantsYouWatchPage.deviantsBar.deviantsSearchButton.a11y.label'
      )}
    />
  ) : (
    <IconButtonWithPopover
      popoverChildren={
        <DeviantsListCard
          selectedUserId={selectedUserId}
          onItemClick={onItemClick}
        />
      }
      aria-label={t(
        'deviantsYouWatchPage.deviantsBar.deviantsSearchButton.a11y.label'
      )}
      onOpenBiData={{
        evid: BiEventType.MORE_MENU_CLICK,
      }}
    >
      <div className={s['root']}>
        <img
          src="https://st.deviantart.net/eclipse/global/svg/deviant-search-button.svg"
          alt={t('browseHeader.page.search')}
        />
      </div>
    </IconButtonWithPopover>
  );
};
DeviantsSearchButton.displayName = 'DeviantsSearchButton';

export default DeviantsSearchButton;
